import React, { useRef, useEffect } from 'react';
import { Header } from '../types';
import * as S from './style';

interface FieldsDropdownProps {
  headers: Header[];
  onSelect: (header: Header) => void;
  close: () => void;
}

const FieldsDropdown: React.FC<FieldsDropdownProps> = ({ headers, onSelect, close }) => {
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        close();
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [close]);

  return (
    <S.DropdownContainer ref={dropdownRef}>
      {headers.map((header) => (
        <S.DropdownItem key={header.key} onClick={() => onSelect(header)}>
          {header.label}
        </S.DropdownItem>
      ))}
    </S.DropdownContainer>
  );
};

export default FieldsDropdown;